import React, { useEffect, useState } from "react";
import IndexComponent from "./Index.component";
import { getCurrentLangName } from "helpers/String.helper";
import * as StudentApi from "api/student/Student.api";
import * as commonData from "data/common.data";
import * as ProfileApi from "api/student/Profile.api";
import { usePopup } from "contexts/PopupContext";
import AgencyInfoPopupContainer from "../popup/AgencyInfoPopup.container";

const IndexContainer = () => {
    const { showPopup } = usePopup();

    const [isLoading, setIsLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState("");

    const [viewCount, setViewCount] = useState(0);
    const [favoriteCount, setFavoriteCount] = useState(0);
    const [todayViewCount, setTodayViewCount] = useState(0);
    const [agencyViewCount, setAgencyViewCount] = useState(0);
    const [fanpageViewCount, setFanpageViewCount] = useState(0);
    const [castingManagerViewCount, setCastingManagerViewCount] = useState(0);

    useEffect(() => {
        getInfo();
    }, []);

    const getInfo = async () => {
        try {
            const data = await ProfileApi.getProfileSummary();

            if (data) {
                setViewCount(data.viewCount);
                setFavoriteCount(data.favoriteCount);
                setTodayViewCount(data.todayViewCount);
                setAgencyViewCount(data.agencyViewCount);
                setFanpageViewCount(data.fanpageViewCount);
                setCastingManagerViewCount(data.castingManagerViewCount);
                setIsLoading(false);
            }
        } catch (error: any) {
            console.log(error);
            setErrorMessage(error.message || "Unknown error occurred");

        } finally {
            setIsLoading(false);
        }
    };

    const showAgencyInfoPopup = (agencyId: number) => {
        showPopup(<AgencyInfoPopupContainer
            agencyId={agencyId}
        />);
    };

    return <IndexComponent
        viewCount={viewCount}
        favoriteCount={favoriteCount}
        todayViewCount={todayViewCount}
        agencyViewCount={agencyViewCount}
        fanpageViewCount={fanpageViewCount}
        castingManagerViewCount={castingManagerViewCount}
        isLoading={isLoading}
        errorMessage={errorMessage}
        showAgencyInfoPopup={showAgencyInfoPopup}
    />
};

export default IndexContainer;